var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrdersWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M6.90625 22.9531V5.07812C6.90625 3.96094 7.82031 3.04688 8.9375 3.04688H5.89062C4.77344 3.04688 3.85938 3.96094 3.85938 5.07812V22.9531C3.85938 24.0703 4.77344 24.9844 5.89062 24.9844H8.9375C7.82031 24.9844 6.90625 24.0703 6.90625 22.9531Z",
    fill: "url(#paint0_linear_3799_7137)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9844 10.7656H18.0781",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9844 14.8281H18.0781",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9844 18.8906H18.0781",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95312 3.04688C9.95312 4.16868 10.8626 5.07812 11.9844 5.07812H14.0156C15.1374 5.07812 16.0469 4.16868 16.0469 3.04688C16.0469 1.92507 15.1374 1.01562 14.0156 1.01562H11.9844C10.8626 1.01562 9.95312 1.92507 9.95312 3.04688ZM9.95312 3.04688H5.89062C4.76882 3.04688 3.85938 3.95632 3.85938 5.07812V22.9531C3.85938 24.0749 4.76882 24.9844 5.89062 24.9844H20.1094C21.2312 24.9844 22.1406 24.0749 22.1406 22.9531V5.07812C22.1406 3.95632 21.2312 3.04688 20.1094 3.04688",
    stroke: "url(#paint1_linear_3799_7137)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3799_7137",
    x1: 3.85937,
    y1: 3.04687,
    x2: 14.8159,
    y2: 6.53853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3799_7137",
    x1: 4.18644,
    y1: -1.67943,
    x2: 30.4691,
    y2: 17.1175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersWhite);
export default __webpack_public_path__ + "static/media/ordersWhite.9695bf3872c3190d22d0e6d76933818b.svg";
export { ForwardRef as ReactComponent };